import ContactMailIcon from '@mui/icons-material/ContactMail';
import DoneIcon from '@mui/icons-material/Done';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ShortTextIcon from '@mui/icons-material/ShortText';

import i18n from 'FRONTEND/utils/i18n';

export const getReasonStepSupport = () => {
  return {
    title: i18n._('Anything left to do?'),
    text: i18n._('All your appointment settings are displayed. Click on any of them in order to change it.'),
    paragraphList: [
      {
        title: i18n._('Edit the appointment reason'),
        text: i18n._('A default appointment reason has been generated but you can still change it. It will be displayed in the participants calendars, in their notifications and in the video call.'),
        icon: ShortTextIcon,
      },
      {
        title: i18n._('Modify the patient contact information'),
        text: i18n._('You can check and edit the patient contact information so that they can receive (or not) a notification and a reminder for the appointment you are setting. To do so, just click the "Edit email address" button.'),
        icon: ContactMailIcon,
      },
      {
        title: i18n._('Let the notifications be sent'),
        text: i18n._('If they do not have disabled them, invited practitioners will receive notifications upon appointment creation, cancellation, or some time before its starts, as a reminder.'), // TODO: clarify and detail according to spec
        icon: NotificationsActiveIcon,
      },
      {
        title: i18n._('Confirm the creation'),
        text: i18n._('Once you are satisfied with all the options you set, create the appointment by clicking the "Finish" button. Invited practitioners that did not delegate their calendar to you will have to approve the appointment.'),
        icon: DoneIcon,
      },
    ],
  };
};
